// @ts-nocheck
import { useEffect } from "react";
import LogoImpressao from "../../assets/logo-impressao.png";

import {
  Container,
  PageContent,
  PageHeader,
  Content,
  Services,
} from "./styles";

import { useRequirement } from "../../hooks/requirement";

export function Impressao() {
  const { requirement, removeRequirement } = useRequirement();
  // A página imprime uma lista; o hook guarda um único requisito/processo.
  const itens = requirement && Object.keys(requirement).length ? [requirement] : [];

  window.onload = function () {
    window.print();
    window.close();
    removeRequirement();
  };

  return (
    <Container id="print">
      <PageContent>
        <PageHeader>
          <img src={LogoImpressao} alt="Logo Cidadania" />
          <p>Documentação necessária</p>
        </PageHeader>
        <p className="infos">
          Após reunir todos os documentos listados abaixo e de acordo com as
          especificações, você deverá enviar para o nosso escritório,
          pessoalmente ou pelos Correios.
          <br />O endereço é: Rua Rodrigo Silva, 30 - sala Cidadania Já, Centro. CEP:
          20011-040. Rio de Janeiro/RJ
        </p> 
        {requirement?.sale?.family_plan === "ESSENTIAL" && (
          <><p>
            <span style={{ fontWeight: "bold" }}>
              ⚠️ Atenção: É necessário realizar o apostilamento de cada documento <b>(exceto para a procuração)</b> para que eles sejam incluídos no processo. O apostilamento é realizado em cartório de sua escolha e deve ser feito antes de enviar para nosso escritório.
            </span>
          </p>
          <p>
            <span style={{ fontWeight: "bold" }}>
              ⚠️ Atenção: Atenção: Certidões digitais em inteiro teor (digitada ou reprográfica) 
              emitidas pelo site do Registro Civil não são aceitas no processo, porque possuem validade 
              de 30 dias, sendo necessário realizar a materialização dentro desse período.
            </span><br></br>
            <span style={{ fontWeight: "bold" }}>
              Para o processo, são aceitas apenas certidões originais, ou seja, documentos físicos 
              emitidos em papel de segurança de cartório. Além disso, a documentação deve ser enviada 
              fisicamente para o endereço do escritório.
            </span>
          </p><br></br>
          </>
          )}
        {itens.length > 0 &&
          itens.map((req) => (
            <Content key={req.id}>
              <p className="title">{req.applicant.name}</p>
              <p className="service">Tipo do serviço: {req.type}</p>
              {req.service_documents.map((document) => (
                <Services>
                  <p className="title">
                    <div />
                    {document.name}
                  </p>
                  {(req.sale?.family_plan === "ESSENTIAL" && (document.name?.includes("Procuração"))) && (
                    <p style={{ fontWeight: "bold" }}>
                      ⚠️ Não precisa de apostilamento
                    </p>
                  )}
                  <p>
                    {document?.format} {document?.name}
                    {document?.from_who && " "}
                    {document?.from_who &&
                      document?.from_who.replace(
                        "applicant",
                        req?.applicant?.name
                      )}
                    {document.specification && ", "}
                    {document?.specification}
                  </p>
                </Services>
              ))}
            </Content>
          ))}
      </PageContent>
    </Container>
  );
}
